var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-data-editor',{attrs:{"id":_vm.id,"title":"Редактирование производителя","resource":"manufacturers","elements":_vm.elements,"add-message":"Производитель добавлен","edit-message":"Производитель изменен"},on:{"change":payload => (_vm.isChanged = payload)}})
}
var staticRenderFns = []

export { render, staticRenderFns }